import { UPDATE_PROFILE } from "../../utils/constants";

export const updateProfile = (profileFluctuate) => ({
  type: UPDATE_PROFILE,
  payload: profileFluctuate
});
